import { TrainingApplyStatus } from "@bbj-types/apply/training";
import { formContactSchema } from "@complex/Contact/Dropdown/resolver";
import { yupResolver } from "@hookform/resolvers/yup";
import type { RichTextValue } from "@root/types/richText";
import { TrainingOfferModality } from "@root/utils/enums/offer";
import { addressSchema } from "@root/utils/resolvers/address";
import { documentSchema } from "@root/utils/resolvers/document";
import { type InferType, array, boolean, date, mixed, object, string } from "yup";
import type { IModalTrainingApplyForm } from "../types";

const richTextSchema = object({
  html: string().defined(),
  text: string().defined(),
}) satisfies ReturnType<typeof object<RichTextValue>>;

const formDocumentSchema = object({
  file: mixed((input): input is File => input instanceof File)
    .default(undefined)
    .optional(),
  info: documentSchema.default(undefined).optional(),
});

const periodSchema = object({
  startDate: date().required("Ce champ est requis"),
  endDate: date().required("Ce champ est requis"),
}).required("Ce champ est requis");

export const formSchema = object({
  status: string()
    .oneOf(Object.values(TrainingApplyStatus), "Ce champ est requis")
    .defined()
    .required("Ce champ est requis"),
  createAssociatedOffer: boolean().defined().default(false),
  name: string().required("Ce champ est requis"),
  period: periodSchema,
  validation: string().oneOf([TrainingOfferModality.QUALIFYING, TrainingOfferModality.CERTIFYING, ""]).defined(),
  wage: string().oneOf([TrainingOfferModality.PAID, TrainingOfferModality.UNPAID, ""]).defined(),
  description: richTextSchema.optional(),
  beneficiaries: richTextSchema.optional(),
  trainingModalities: richTextSchema.optional(),
  financingModes: richTextSchema.optional(),
  registrationModalities: richTextSchema.optional(),
  url: string(),
  structureName: string().required("Ce champ est requis"),
  address: addressSchema.nullable().defined(),
  remote: string().oneOf([TrainingOfferModality.FULL_REMOTE]).nullable().defined(),
  structureWebsite: string(),
  contact: formContactSchema.nullable().defined(),
  documents: array(formDocumentSchema.required()).ensure().max(5).defined(),
});

export const formResolver = yupResolver<IModalTrainingApplyForm>(formSchema);
export type TModalTrainingApplyFormResolver = InferType<typeof formSchema>;
